import { ConfirmationStage, EnterDetailsStage } from "./stages";
import { UpdatePartitionCallOffCodeRequest, UpdatePartitionRequest, updatePartition, updatePartitionCallOffCode } from "domains/partitions/services/partition-service";
import { useCallback, useState } from "react";
import { useGetPartitionById, useGetPartitionCallOffCodeById } from "domains/partitions/services/use-partition-api";

import { IntroStage } from "features/common/stages";
import Wizard from "features/common/Wizard";
import localisations from "features/localisation";

type EditPartitionFeatureProps = {
    fieldCompanyId: number;
    partitionId: string;
};

export default function EditPartitionFeature(props: EditPartitionFeatureProps) {
    const { loading, data } = useGetPartitionById(props.partitionId);
    const callOffCodeResponse = useGetPartitionCallOffCodeById(props.partitionId);

    const [fields, setFields] = useState({} as any);
    const { intro, enterDetails, confirmation } = localisations.editPartition.stepper;

    const handleFieldChange = useCallback((newFields: any) => setFields((x:any) => ({ ...x, ...newFields })), [setFields]);

    const editPartitionFromFeatureFields = async () => {
        if (!fields.id) {
            return true;
        }

        let request = {
            name: fields.name,
            reference: fields.reference,
            ownerEmail: fields.emailAddress,
            notes: fields.notes,
        } as UpdatePartitionRequest;

        await updatePartition(props.partitionId, request);

        if (fields.callOffCodes && callOffCodeResponse.data && fields.callOffCodes !== callOffCodeResponse.data.callOffCodes) {
            try {
                await updatePartitionCallOffCode(fields.id, { callOffCodes: fields.callOffCodes } as UpdatePartitionCallOffCodeRequest);
            }
            catch {
                alert("Unable to update the Call Off Code.");
            }
        }

        return true;
    };

    return (
        <>
        {!loading && data && !callOffCodeResponse.loading && callOffCodeResponse.data ? (
        <Wizard
            fieldCompanyId={props.fieldCompanyId}
            steps={[
                {
                    label: intro,
                    component: <IntroStage localisations={localisations.editPartition.stages.intro} />
                },
                {
                    label: enterDetails,
                    component: <EnterDetailsStage 
                        fields={fields.id ? fields : ({...data, ...{ emailAddress: data.ownerEmail, callOffCodes: callOffCodeResponse.data.callOffCodes }}) } 
                        handleFieldChange={handleFieldChange} />
                },
                {
                    label: confirmation,
                    component: <ConfirmationStage fields={fields} />,
                    onNext: editPartitionFromFeatureFields
                },
            ]}
            resultStageLocalisations={localisations.editPartition.stages.result}
            serverErrorLocalisations={localisations.editPartition.serverErrors}
        />) : null }
        {!loading && !data ? (<div>Unknown Partition</div>) : null }
        </>
    );
}
